export default "__VITE_ASSET__DIG$IgjO__"